import PatientScheduleFormContainer from './PatientScheduleFormContainer';

export default PatientScheduleFormContainer;
